import { render, staticRenderFns } from "./EditorSection.vue?vue&type=template&id=672a9104&"
import script from "./EditorSection.vue?vue&type=script&lang=js&"
export * from "./EditorSection.vue?vue&type=script&lang=js&"
import style0 from "./EditorSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports